import queryString from "query-string";

export const fetchPlaces = (): Function => (state, actions): Promise<void> => {
  const {
    api,
    clientID,
    places: {
      category: { id: categoryID },
      pagination: { pageNumber, pageSize },
    },
  } = state;

  const headers = new Headers({ authorization: state.authorization });

  const fetching = fetch(
    `${api}/v1/places/${clientID}?${queryString.stringify({
      categoryID,
      pageNumber,
      pageSize,
    })}`,
    { headers },
  );

  fetching
    .then(response => response.json())
    .then(({ places }) => {
      actions.setPlaces({ pageNumber, pageSize, places });
      actions.fetchPlacesCount({ categoryID, pageNumber, pageSize });
    })
    .catch(reason => actions.setPlacesFailed({ reason }));

  return {
    ...state,
    places: {
      ...state.places,
      loadingPlaces: true,
    },
  };
};
